module.exports = __webpack_public_path__ + "static/media/icons_Bilan de paralysie faciale.008fc32b.svg";